/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

export default function HierarchyHorizontal({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.9624 1.6438L8.9624 2.57718L8.37982 2.57718C7.46368 2.57718 6.71783 3.32272 6.71783 4.23917L6.71783 7.28268L5.50629 7.28268L5.50629 6.16879C5.50629 5.53754 4.9939 5.01874 4.36249 5.01874L1.1438 5.01874C0.51239 5.01874 -4.35473e-07 5.53754 -4.0788e-07 6.16879L-2.55708e-07 9.65009C-2.28115e-07 10.2813 0.51239 10.7938 1.1438 10.7938L4.36249 10.7938C4.9939 10.7938 5.50629 10.2813 5.50629 9.65009L5.50629 8.53268L6.71783 8.53268L6.71783 11.5765C6.71783 12.4926 7.46368 13.2382 8.37982 13.2382L8.9624 13.2382L8.9624 14.3563C8.9624 14.9875 9.4751 15.5 10.1062 15.5L13.3249 15.5C13.9563 15.5 14.4687 14.9875 14.4687 14.3563L14.4687 10.8751C14.4687 10.2438 13.9563 9.72501 13.3249 9.72501L10.1062 9.72501C9.4751 9.72501 8.9624 10.2438 8.9624 10.8751L8.9624 11.9882L8.37982 11.9882C8.15277 11.9882 7.96783 11.8036 7.96783 11.5765L7.96783 7.90768L7.96783 4.23917C7.96783 4.01212 8.15277 3.82718 8.37982 3.82718L8.9624 3.82718L8.9624 5.12509C8.9624 5.75635 9.4751 6.26874 10.1062 6.26874L13.3249 6.26874C13.9563 6.26874 14.4687 5.75635 14.4687 5.12509L14.4687 1.6438C14.4687 1.01254 13.9563 0.499999 13.3249 0.499999L10.1062 0.5C9.4751 0.5 8.9624 1.01254 8.9624 1.6438Z" fill="#B8C7D8"/>
    </svg>
  );
}

HierarchyHorizontal.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

HierarchyHorizontal.defaultProps = {
  width: 15,
  height: 16,
};
